document.addEventListener('DOMContentLoaded', function() {
  var trigger = document.getElementById('open-cookie-preferences');
  if (!trigger) return;

  trigger.addEventListener('click', function(e) {
    e.preventDefault();

    if (!document.getElementById('silktide-modal') && window.silktideCookieBannerManager?.initCookieBanner) {
      window.silktideCookieBannerManager.initCookieBanner();
    }

    var modal = document.getElementById('silktide-modal');
    if (modal) {
      modal.style.display = 'flex';
      var backdrop = document.getElementById('silktide-backdrop');
      if (backdrop) backdrop.style.display = 'block';
    }
  });
});